export const WwwRouteConstants = {
  SECURE: 'e',
  APICONTEXT: 'apicontext',
  REDIRECT: 'redirect',
  FO: 'store',
  BO: 'admin',
  MEMBER: 'member'
};
